import {
  CALENDAR_TYPE_BIRTHDAY,
  CALENDAR_TYPE_EVENT,
  CALENDAR_TYPE_TASK,
  plannerCalendarNormalizedType,
} from '../../moduleServices/planner_calendar_types';
import { isMultiDayEvent, eventIsAllDay } from './calendar_grid_utils';

export const sortByStartTs = (a, b) => {
  const aTime = new Date(a.start_datetime || a.start_date || 0).getTime();
  const bTime = new Date(b.start_datetime || b.start_date || 0).getTime();
  return aTime - bTime;
};

/**
 * Ordem na célula / day sheet:
 * 1) Multi-dia (qualquer tipo de calendário)
 * 2) Dia único: birthdays
 * 3) Dia único: tasks
 * 4) Dia único: type_event all-day
 * 5) Dia único: type_event com horário (por instante de início)
 *
 * Restante (marginal) vai para `fallback`.
 * `suppressMultiDay`: exclui multi-dias da entrada ( grupo 1 fica vazio ).
 */
export function getOrderedCellEvents(dayEvents, suppressMultiDay = false) {
  if (!dayEvents?.length) return [];

  const list = suppressMultiDay ? dayEvents.filter((ev) => !isMultiDayEvent(ev)) : [...dayEvents];

  const multis = suppressMultiDay ? [] : list.filter((ev) => isMultiDayEvent(ev));
  const nonMulti = suppressMultiDay ? list : list.filter((ev) => !isMultiDayEvent(ev));

  const birthdays = [];
  const tasks = [];
  const eventAllDaySingles = [];
  const eventTimedSingles = [];
  const fallback = [];

  for (const ev of nonMulti) {
    const kind = plannerCalendarNormalizedType(ev?.calendar);
    if (kind === CALENDAR_TYPE_BIRTHDAY) {
      birthdays.push(ev);
      continue;
    }
    if (kind === CALENDAR_TYPE_TASK) {
      tasks.push(ev);
      continue;
    }
    if (kind === CALENDAR_TYPE_EVENT) {
      if (eventIsAllDay(ev)) eventAllDaySingles.push(ev);
      else if (ev.start_datetime) eventTimedSingles.push(ev);
      else fallback.push(ev);
      continue;
    }
    fallback.push(ev);
  }

  multis.sort(sortByStartTs);
  birthdays.sort(sortByStartTs);
  tasks.sort(sortByStartTs);
  eventAllDaySingles.sort(sortByStartTs);
  eventTimedSingles.sort(sortByStartTs);
  fallback.sort(sortByStartTs);

  return [
    ...multis,
    ...birthdays,
    ...tasks,
    ...eventAllDaySingles,
    ...eventTimedSingles,
    ...fallback,
  ];
}
